module.exports = __webpack_public_path__ + "img/周老师-1.1c0ef75d.png";